
import svg4everybody from "svg4everybody";
import $ from "jquery";
import Page from "webPage/Page";
import GlobalEvents from "base/GlobalEvents";
import NavigationHover from "./NavigationHover";
import "simplebar";
import "objectFitPolyfill";
import CookieHelper from "base/CookieHelper";

$(function () {
    document.documentElement.setAttribute('data-useragent', navigator.userAgent);
    if (!!window.MSInputMethodContext && !!document.documentMode) {
        $('html').addClass('ie11');
    }

    svg4everybody();
    Page.init();
    NavigationHover.init();

    let resizeTimeout;

    $(window).on("scroll", function () {
        if ($(this).scrollTop() > 0) {
            $("body").addClass("sticky-active");
        } else {
            $("body").removeClass("sticky-active");
        }
    }).scroll().on('resize', function () {
        if (resizeTimeout) clearTimeout(resizeTimeout);
        $('body').addClass('resizing');
        resizeTimeout = setTimeout(() => {
            $('body').removeClass('resizing');
        });
        updateNotificationOffset();
    });

    $('body').on('click', '.js-menu-btn', function () {
        $('body').toggleClass('menu-active');
        $(".menu-btn").addClass("menu-btn--close");
        return false;
    }).on('click', '.js-switch-language', function () {
        let value = $(this).attr("data-language");

        if (value === 'English') {
            let $frame = $(".goog-te-banner-frame:first");

            if (!$frame.length) {
                return false;
            }
            $frame.contents().find('.goog-close-link').get(0).click();

            return false;
        }
        let $frame = $('.goog-te-menu-frame:first');
        if (!$frame.length) {
            return false;
        }
        $frame.contents().find('.goog-te-menu2-item span.text:contains(' + value + ')').get(0).click();
        return false;
    }).on('click', '.js-support-btn', function () {
        $('.support__dropdown').toggleClass('support__dropdown--active');
        return false;
    }).on('click', '.js-menu-item', function (e) {
        let $target = $(e.target);
        if ($target.is(".menu__dropdown") || $target.parents(".menu__dropdown").length > 0) return;

        if ($(window).outerWidth() < 960) {
            $(this).toggleClass('menu__item--active');
        }
        return false;
    }).on('mousedown', '.js-menu-item', function (e) {
        e.preventDefault();
        return false;
    }).on('click', '.js-toggle-footer-list', function () {
        if ($(window).outerWidth() < 625) {
            $(this).parent().toggleClass('footer__item--active');
        }
    }).on('click', '.js-toggle-languages', function () {
        if ($(window).outerWidth() < 625) {
            $(this).parent().toggleClass('footer__languages--active');
            return false;
        }
    }).on('click', function (e) {
        if ($("body").is(".menu-active")) {
            let $target = $(e.target);
            if (!$target.is(".menu") && $target.parents('.menu').length === 0) {
                $("body").removeClass("menu-active");
                $(".menu-btn").addClass("menu-btn--close");
                return false;
            }
        }
    }).on("click", ".js-modal", (e) => e.stopPropagation()).on("click", ".js-modal-wrap, .js-modal-close", () => {
        GlobalEvents.emit('website.modal.close');
        $("body").removeClass("modal-active");
        $(".modal--active").removeClass("modal--active");
        return false;
    }).on("click", ".js-dismiss-notification, .js-view-notification", function () {
        let $this = $(this);

        let timestamp = $this.parents(".swn").attr("data-timestamp");

        CookieHelper.set('seen-notification', timestamp, 365);

        if ($this.is(".js-dismiss-notification")) {
            $("body").removeClass("has-notification");
            $this.parents(".swn").remove();
            updateNotificationOffset();
            return false;
        }
    });

    updateNotificationOffset();

    function updateNotificationOffset() {
        let $notification = $(".swn");

        if ($notification.length === 0) {
            $(".header,.menu,.menu-btn").css("top", "");
            $("body").css("margin-top", "");
        } else {
            let size = $notification.outerHeight();
//            if ($("body").is(".has-toolbar")) {
//                size += $(".admin-toolbar").outerHeight();
//            }

            $(".header,.menu").css("top", size + "px");
            $("body").css("margin-top", size + "px");
            $(".menu-btn").css("top", (($(window).outerWidth() >= 500 ? 47 : 26) + size) + "px");
        }
    }
});
